import { Component, OnChanges, Input, OnInit } from '@angular/core';
import * as c3 from 'c3';

@Component({
  selector: 'app-pie-chart-sql',
  templateUrl: './pie-chart-sql.component.html',
  styleUrls: ['./pie-chart-sql.component.scss']
})
// Created a pie chart component for 4M section in dashboard
export class PieChartSqlComponent implements OnChanges {
  @Input() fourmsData: Array<any> = [];
  width = 0;
  height = 0;
  public innerwidth: any;
  constructor() {}
  ngOnChanges() {
    this.innerwidth = window.innerWidth;
    this.pieChartSizeUpdate();
    this.loadPieChart();
  }
  pieChartSizeUpdate() {
    if (this.innerwidth > 768 && this.innerwidth < 850) {
      this.width = 200;
      this.height = 200;
    } else if (this.innerwidth > 850 && this.innerwidth < 964) {
      this.width = 220;
      this.height = 220;
    } else if (this.innerwidth > 965 && this.innerwidth < 1024) {
      this.width = 250;
      this.height = 250;
    } else if (this.innerwidth > 1024 && this.innerwidth < 1280) {
      this.width = 300;
      this.height = 300;
    } else if (this.innerwidth > 1280 && this.innerwidth < 1366) {
      this.width = 340;
      this.height = 340;
    } else if (this.innerwidth > 1366 && this.innerwidth < 1536) {
      this.width = 340;
      this.height = 340;
    } else if (this.innerwidth > 1536) {
      this.width = 360;
      this.height = 360;
    }
  }
  loadPieChart() {
    const foruMsArrayData = Object.keys(this.fourmsData).map(v => new Array(v, this.fourmsData[v]));
    c3.generate({
      bindto: '#chart1',
      size: {
        height: this.height,
        width: this.width
      },
      data: {
        columns: foruMsArrayData,
        type: 'pie'
      },
      color: {
          // man machine method material
        pattern: ['#FDBF6F', '#8F82C7', '#82C7C2', '#D27969']
      }
    });
  }
  onResize(event) {
    this.innerwidth = event.target.innerWidth;
    this.pieChartSizeUpdate();
    this.loadPieChart();
  }
}
